<template>
  <el-form
      @submit.prevent="triggerFormSubmit"
      ref="refFormName"
      :rules="modelRules"
      :model="model"
      class="common-form">
    <h2 class="text-[13px] font-semibold text-[#23569F] uppercase leading-[1.5]">{{ $t('playerSetup.playerName') }}</h2>
    <el-row>
      <el-col :span="10" :offset="8">
        <div class="grid-content">
          <player-setup-form-error :message="formError" :display="formError != ''" height="short" />
            <el-form-item :label="$t('playerSetup.playerNamePlaceholder')" prop="name">
              <el-input
                ref="nameInput"
                :autofocus="true"
                 :disabled="isFormDisabled"
                 v-model="model.name"
                 :placeholder="$t('label.nameYourPlayerEGReception')">
                 <template #suffix>
                  <span v-if="model.name" class="flex cursor-pointer" @click="() => $refs.nameInput.clear()">
                    <el-icon class="text-[#c0c4cc] hover:text-[#909399]"><CircleClose /></el-icon>
                  </span>
                </template>
              </el-input>
            </el-form-item>
        </div>
      </el-col>
    </el-row>
    <h2 class="text-sm font-semibold text-[#23569F] uppercase mt-[40px]">{{ $t('label.timeZone') }}</h2>
    <el-row class="mt-1">
      <el-col :span="10" :offset="8">
        <el-form-item :label="$t('label.timeZone')" prop="timezone" class="mt-8 mb-0">
          <el-select
              filterable
              ref="timezoneInput"
              :disabled="isFormDisabled"
              v-model="model.timezone"
              value-key="id"
              :validate-event="true"
              :placeholder="timezone">
            <el-option
              v-for="item in timezones"
              :key="item.id"
              :label="item.label"
              :value="item">
            </el-option>
          </el-select>

        </el-form-item>
        <p class="text-xs input-hint mt-3 mx-0">{{ $t('playerSetup.playerTimezoneHint') }}</p>
      </el-col>
    </el-row>
</el-form>
</template>

<script src="./player-setup-name.js"></script>
